var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("card_list_page.form_title")) + " ")]), _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('card_list_page.form_desc'))
    }
  }), _vm.getModuleConfig('card_list_page.content') ? _c('div', {
    staticClass: "page__content",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('exchange_records_page.content'))
    }
  }) : _vm._e(), _c('div', {
    staticClass: "reward-card-list"
  }, [_vm.cardList.length > 0 ? _vm._l(_vm.cardList, function (item) {
    return _c('router-link', {
      key: item.id,
      staticClass: "reward-card-list__item",
      attrs: {
        "to": {
          name: 'LiffProjAbbottAndRewardsCardDetail',
          params: {
            orgCode: _vm.$route.params.orgCode,
            id: item.id
          }
        }
      }
    }, [_c('div', [_c('div', {
      staticClass: "reward-card-list__image"
    }, [_c('img', {
      attrs: {
        "src": item.img_url || './product-image.png'
      }
    })]), _c('div', {
      staticClass: "reward-card-list__stamp"
    }, _vm._l(item.threshold, function (i) {
      return _c('i', {
        key: i,
        staticClass: "fa fa-star",
        class: item.point >= i && 'active',
        attrs: {
          "aria-hidden": "true"
        }
      });
    }), 0)]), _c('div', {
      staticClass: "reward-card-list__content"
    }, [_c('div', {
      staticClass: "reward-card-list__title"
    }, [_vm._v(_vm._s(item.name))]), _c('div', {
      staticClass: "reward-card-list__date"
    }, [_vm._v("開始日期" + _vm._s(_vm.formatDate(item.start_at)))]), _c('div', {
      staticClass: "reward-card-list__date"
    }, [_vm._v("到期日期" + _vm._s(_vm.formatDate(item.end_at)))])])]);
  }) : [_vm._m(0)]], 2)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "reward-card-list__item"
  }, [_c('div', {
    staticClass: "reward-card-list__content"
  }, [_c('div', {
    staticClass: "reward-card-list__title"
  }, [_vm._v("您現在暫時沒有集點卡")])])]);
}]

export { render, staticRenderFns }